<template>
  <v-snackbar v-model="show" :timeout="5000" top multi-line right :color="type">
    {{message}}
    <v-icon left color="#fff" @click.native="show = false" style="cursor:pointer">fa-times</v-icon>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "",
      type: ""
    };
  },
  created: function() {
    this.$store.watch(
      state => state.user.snack,
      () => {
        const msg = this.$store.state.user.snack;
        const type = this.$store.state.user.type;
        if (msg !== "") {
          this.show = true;
          this.message = msg;
          this.type = type;
          this.$store.dispatch("user/setSnack", "");
          this.$store.dispatch("user/setType", "");
        }
      }
    );
  }
};
</script>
